<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span v-if="question.id!=null && question.id!=''">Асуулт засах</span>
                      <span v-else>Асуулт нэмэх</span>
                    </h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <input
                        v-model.trim="question.name"
                        type="text"
                        class="form-control"
                        id="exampleInputEmail"
                        aria-describedby="emailHelp"
                        placeholder="Асуултын нэр"
                      />
                    </div>
                    <div class="form-group">
                      <textarea
                        v-model.trim="question.description"
                        type="text"
                        class="form-control"
                        id="exampleInputPassword"
                        placeholder="Дэлгэрэнгүй"
                        rows="10"
                      />
                    </div>
                    <div class="form-group">
                      <div class="custom-control custom-checkbox small">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck"
                          v-model="question.multichoice"
                        />
                        <label class="custom-control-label" for="customCheck">Олон хариулттай эсэх</label>
                      </div>
                    </div>
                    <div class="form-group">
                      <input type="file" ref="file" accept="image/*" @change="onFileChange">
                      <img v-if="imagePreview!=null" :src="imagePreview"  class="img-fluid" alt="Image"/>
                      <img v-else-if="question.image!=null" :src="question.image.fileUrl"  class="img-fluid" alt="Image"/>
         
                    </div>
                    <div class="form-group">
                      <div class="justify-content-between">
                        <div
                          class="btn btn-success btn-small"
                          v-on:click="addAnswerBulk"
                        >Хариулт бөөнөөр нэмэх</div>
                      </div>
                      <br/>
                      <textarea
                        rows="10"
                        v-model.trim="bulkAnswers"
                        class="form-control"
                        placeholder="Xариултаа xуулаад энд тавиx"
                      />
                    </div>
                    <div class="form-group">
                      <div class="justify-content-between">
                        <div class="btn btn-success btn-small" v-on:click="addAnswer">Хариулт нэмэх</div>
                      </div>
                      <br/>
                      <div v-if="answers!=null && answers.length>0">
                        <div
                           class="row my-3"
                          v-for="(answer,index) in answers"
                          v-bind:key="'answer_'+index"
                        >
                          <div class="col col-auto">
                            <textarea
                              v-model.trim="answer.name"
                              type="text"
                              class="form-control"
                              placeholder="Хариулт"
                            />
                          </div>
                          <div class="col col-md-2">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                v-model="answer.correct"
                              />
                              <label class="form-check-label" for="exampleCheck1">Зөв хариулт</label>
                            </div>
                            <i class="fas fa-trash" @click="remove(index, answers)"></i>
                          </div>
                          <div class="col col-auto">
                            <input type="file" :ref="'answerFile_' + index"  accept="image/*" @change="onAnswerFileChange('answerFile_' + index, index, answer)">
                            <img style="height:48px;width:48px;" v-if="answer.imagePreview!=null" :src="answer.imagePreview"  class="img" alt="Image"/>
                            <img style="height:48px;width:48px;" v-else-if="answer.image!=null" :src="answer.image.fileUrl"  class="img" alt="Image"/>
                          </div>
                          
                         
                        </div>

                      </div>
                      <div v-else class="alert alert-danger">Одоогоор хариулт оруулаагүй байна.</div>
                    </div>

                    <hr />
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">Хадгалах</div>
                      </div>
                    </div>
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
export default {
  name: "QuestionAdd",
  data() {
    return {
      bulkAnswers:null,
      question: {
        name: "",
        description: "",
        multichoice: false
      },
      deletedAnswers:[],
      answers:[],
      tmpAnswer:{
          'name':'',
          'correct':false,
          imagePreview:null
      },
      lessonRef:null,

      tmpImage:null,
      imagePreview:null
        };
    },
    methods: {
      addAnswerBulk() {
      if (this.bulkAnswers != null && this.bulkAnswers != "") {
        var arrayOfLines = this.bulkAnswers.match(/[^\r\n]+/g);
        arrayOfLines.forEach(value => {
           console.log(value);
        
           this.answers.push({
            name: value.charAt(0).toUpperCase()+value.slice(1),
            correct: false, 
            imagePreview:null
          });
         
        });
        //this.bulkAnswers = "";
      }

     
    },
        save() {
            this.performingRequest = true
            //NumberOfQuestions
            if(this.question!=null && this.question.name!=''){
                
                var docRef
                if(this.questionId!=null && this.questionId!='' && this.questionId!='new'){
                  this.question.modifiedAt=new Date()
                   docRef=fb.db.collection(this.path).doc(this.questionId)
                   docRef.set(this.question)

            
                  this.answers.forEach((answer, i)=>{
                    if(answer.name!=null && answer.name!=''){
                      answer.index=i;
                      if(answer.id!=null && answer.id!='' && answer.id!=undefined){
                        docRef.collection("answers").doc(answer.id).set(answer)
                      }
                      else
                        docRef.collection("answers").doc(answer.name.substring(0, 20)).set(answer)

                    }
                  })
                  if(this.deletedAnswers!=null && this.deletedAnswers.length>0){
                    this.deletedAnswers.forEach(aid=>{
                      docRef.collection("answers").doc(aid).delete()
                    })
                  }
           
                }
                else{
                  this.question.userId=this.$store.getters.currentUser.uid;
                  this.question.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                  this.question.createdAt=new Date()
                  this.question.lectureCode=new Date().getTime()
                  var now=new Date();
                  docRef=fb.db.collection(this.path).doc(this.question.name.substring(0, 20)+now.getTime())
                  if(this.tmpImage!=null){
                    this.question.image=this.tmpImage
                  }
                  docRef.set(this.question)
                  this.answers.forEach((answer, i)=>{
                    if(answer!=null && answer.name!=null && answer.name!=''){
                      answer.index=i;
                      docRef.collection("answers").doc(answer.name.substring(0, 20)).set(answer)
                      this.saveAnswerFile(answer, ("answerFile_"+i), i, docRef.collection("answers").doc(answer.name.substring(0, 20)))
                    }
                  })
                  this.lessonRef=docRef.parent.parent;
                  if(this.lessonRef!=null){
                    this.lessonRef.update({
                      'numberOfQuestions': fb.firestore.FieldValue.increment(1)
                    })
                  }
                }
                
                var _this=this;
                var files = this.$refs['file'].files

                if(files!=null && files.length>0){
                  var file=files[0]
                  var now=new Date();
                  var fileName=file.name+"_"+now.getTime();
                  var uploadTask = fb.storageRef.child(fileName).put(file);

                  uploadTask.on(fb.storage.TaskEvent.STATE_CHANGED,
                    function(snapshot) {
                      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                    }, function(error) {
                    
                  }, 
                  function() {
                    uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                      if(_this.question.image!=null){
                        _this._deleteFile(_this.question.image.fileName);
                      }
                      let fileObject={
                        'fileName': fileName,
                        'fileUrl':downloadURL,
                        'uploadedAt': now
                      }
                      if(docRef!=null)
                        docRef.update({'image': fileObject})

                      _this.$refs['file'].value = ''

                      if(!/safari/i.test(navigator.userAgent)){
                        _this.$refs['file'].type = ''
                        _this.$refs['file'].type = 'file'
                      }
                    });
                  });
                }
       
                 
                this.$router.back();
            }
        },
        _deleteFile(fileName, index){

            var fileRef = fb.storageRef.child(fileName);

            fileRef.delete().then(() =>{
 
            }).catch(function(error) {

            });       
        },
        setLesson(){
          this.question={
                name: '',
                description: '',
                multichoice:false,
                answers:[]  

            }
        },
        addAnswer(){
          this.answers.push({
                'name':'',
                'correct':false,
                imagePreview:null
            })
        },
        remove(index, array){
          if(array!=null && array.length>0)
          { 

            this.deletedAnswers.push(this.answers[index].id)
             array.splice(index, 1)
          }
        }
        ,
    
    _getQA() {
      console.log(this.path);
      console.log(this.questionId);
      if (this.path != null && this.path != "" && this.questionId != "new") {
        var docRef = fb.db
          .collection(this.path)
          .doc(this.questionId)
          .get()
          .then(doc => {
            console.log(doc.data());
            if (doc.exists) {
              this.question = doc.data();
              this.question.id = doc.id;
              doc.ref
                .collection("answers")
                .get()
                .then(querySnapshot => {
                  querySnapshot.forEach(answer => {
                    let object = answer.data();
                    object.id = answer.id;
                    object.imagePreview=null;
                    this.answers.push(object);
                  });
                });
            }
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
          });
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.imagePreview = URL.createObjectURL(file);
    },
    onAnswerFileChange(refName, index, answer) {
      
      var files = this.$refs[refName][0].files;
      console.log(files)
      if(files!=null && files.length>0){
        
        var file=files[0]
        answer.imagePreview = URL.createObjectURL(file);
        console.log(answer)
      }
    },
    saveAnswerFile(answer, refName, index, answerRef){
      var _this=this;
      var files = this.$refs[refName][0].files;
      if(files!=null && files.length>0){
        var file=files[0]
        var now=new Date();
        var fileName=file.name+"_"+now.getTime();
        var uploadTask = fb.storageRef.child(fileName).put(file);

        uploadTask.on(fb.storage.TaskEvent.STATE_CHANGED,
          function(snapshot) {
            // var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          }, function(error) {
          
        }, 
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            if(answer.image!=null){
              _this._deleteFile(answer.image.fileName);
            }
            let fileObject={
              'fileName': fileName,
              'fileUrl':downloadURL,
              'uploadedAt': now
            }
            if(answerRef!=null)
              answerRef.update({'image': fileObject})
          });
        });
      }
    },
    uploadFile(){

        var _this=this;
        var files = this.$refs['file'].files

        if(files!=null && files.length>0){
          var file=files[0]
          var now=new Date();
          var fileName=now.getTime()+"_"+file.name;
          var uploadTask = fb.storageRef.child(fileName).put(file);

          uploadTask.on(fb.storage.TaskEvent.STATE_CHANGED,
            function(snapshot) {
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                break;

              case 'storage/canceled':
                break;


              case 'storage/unknown':
                break;
            }
          }, 
          function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              
              let fileObject={
                'fileName': fileName,
                'fileUrl':downloadURL,
                'uploadedAt': now
              }


              _this.tmpImage=fileObject;
              _this.$refs['file'].value = ''

              if(!/safari/i.test(navigator.userAgent)){
                _this.$refs['file'].type = ''
                _this.$refs['file'].type = 'file'
              }
            });
          });
        }
        
      },
  },
  props: {
    path: {
      required: true
    },
    questionId: {
      required: false
    }
  },
  created() {
    if (this.path != null && this.path != "" && this.questionId != "new") {
      this._getQA();
    }
  }
};
</script>

